import React, { useEffect, useState } from 'react';
import { contactsAPI } from '../../services/api';
import { useUIStore } from '../../store';

export default function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ full_name: '', phone_cuba: '', province: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const { openSendModal } = useUIStore();

  const provinces = ['La Habana', 'Santiago de Cuba', 'Holguín', 'Camagüey', 'Pinar del Río', 'Santa Clara', 'Matanzas', 'Cienfuegos', 'Guantánamo', 'Las Tunas', 'Granma', 'Sancti Spíritus', 'Ciego de Ávila', 'Artemisa', 'Mayabeque', 'Isla de la Juventud'];

  const load = async () => {
    try {
      const res = await contactsAPI.list();
      setContacts(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setContacts([]);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      await contactsAPI.create(form);
      setForm({ full_name: '', phone_cuba: '', province: '' });
      setShowForm(false);
      load();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar contacto');
    } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este contacto?')) return;
    await contactsAPI.delete(id);
    setContacts(c => c.filter(x => x.id !== id));
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22 }}>
        <div>
          <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 26, margin: '0 0 4px' }}>Contactos en Cuba</h1>
          <p style={{ fontSize: 13, color: '#7a7060', margin: 0 }}>Familiares y personas a quienes envías dinero</p>
        </div>
        <button onClick={() => setShowForm(!showForm)} style={{
          padding: '10px 20px', borderRadius: 8, border: 'none',
          background: '#c94a1e', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
        }}>+ Nuevo contacto</button>
      </div>

      {/* Form */}
      {showForm && (
        <div style={{ background: '#fff', border: '1px solid #e2dbd0', borderRadius: 14, padding: 24, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 18px', fontFamily: 'Georgia,serif', fontSize: 16 }}>Nuevo contacto</h3>
          <form onSubmit={handleSave}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14, marginBottom: 16 }}>
              <div>
                <label style={lbl}>Nombre completo</label>
                <input style={inp} placeholder="María García" value={form.full_name}
                  onChange={e => setForm({ ...form, full_name: e.target.value })} required />
              </div>
              <div>
                <label style={lbl}>Teléfono Cuba</label>
                <input style={inp} placeholder="+53 5234 5678" value={form.phone_cuba}
                  onChange={e => setForm({ ...form, phone_cuba: e.target.value })} required />
              </div>
              <div>
                <label style={lbl}>Provincia</label>
                <select style={{ ...inp, cursor: 'pointer' }} value={form.province}
                  onChange={e => setForm({ ...form, province: e.target.value })}>
                  <option value="">Seleccionar...</option>
                  {provinces.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
            </div>
            {error && <div style={{ color: '#9b2c5e', fontSize: 12, marginBottom: 12, background: '#faeef4', padding: '8px 12px', borderRadius: 6 }}>{error}</div>}
            <div style={{ display: 'flex', gap: 10 }}>
              <button type="submit" disabled={saving} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#c94a1e', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                {saving ? 'Guardando...' : 'Guardar'}
              </button>
              <button type="button" onClick={() => setShowForm(false)} style={{ padding: '9px 20px', borderRadius: 8, border: '1px solid #e2dbd0', background: '#fff', fontSize: 13, cursor: 'pointer' }}>
                Cancelar
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Contacts grid */}
      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#7a7060' }}>Cargando...</div>
      ) : contacts.length === 0 ? (
        <div style={{ background: '#fff', border: '1px solid #e2dbd0', borderRadius: 14, padding: 48, textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>👥</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, marginBottom: 8 }}>Sin contactos todavía</div>
          <div style={{ fontSize: 13, color: '#7a7060', marginBottom: 20 }}>Añade a tus familiares en Cuba para enviarles dinero más rápido.</div>
          <button onClick={() => setShowForm(true)} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: '#c94a1e', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            Añadir primer contacto
          </button>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
          {contacts.map((c, i) => (
            <div key={i} style={{ background: '#fff', border: '1px solid #e2dbd0', borderRadius: 14, padding: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
                <div style={{ width: 44, height: 44, borderRadius: '50%', background: '#c94a1e20', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Georgia,serif', fontSize: 18, color: '#c94a1e', flexShrink: 0 }}>
                  {c.full_name?.charAt(0).toUpperCase()}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{c.full_name}</div>
                  <div style={{ fontSize: 12, color: '#7a7060', fontFamily: 'monospace' }}>{c.phone_cuba}</div>
                </div>
              </div>
              {c.province && (
                <div style={{ fontSize: 12, color: '#7a7060', marginBottom: 14 }}>📍 {c.province}</div>
              )}
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={openSendModal} style={{ flex: 1, padding: '8px', borderRadius: 7, border: 'none', background: '#c94a1e', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  Enviar →
                </button>
                <button onClick={() => handleDelete(c.id)} style={{ padding: '8px 12px', borderRadius: 7, border: '1px solid #e2dbd0', background: '#fff', fontSize: 12, color: '#9b2c5e', cursor: 'pointer' }}>
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const lbl = { display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 6 };
const inp = { width: '100%', padding: '9px 12px', border: '1px solid #e2dbd0', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' };
